import { createAnimations } from "@tamagui/animations-css";

export const animations = createAnimations({
  fast: "ease-in 150ms",
  medium: "ease-in 300ms",
  slow: "ease-in 450ms",
});
